<ng-container *ngIf="display">
  <label *ngIf="withLabel" class="text-secondary fw-medium" [focusTo]="focus" [ngClass]="{ required: required }" translate>{{ label }}</label>
  <ng-content select="[component]"> </ng-content>
  <app-form-validation-errors [fieldTranslationKey]="label" [control]="control" [params]="params"></app-form-validation-errors>
</ng-container>
